<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <div class="d-flex align-items-center">
          <b-button
            variant="primary"
            @click="goToCreateExam"
            class="create-exam-btn mr-2"
            v-if="role_modules.some((item) => item.value == 'exam.create')"
          >
            Create Exam
          </b-button>
          <b-button
            variant="secondary"
            @click="gotoManualGradingExam"
            class="create-exam-btn position-relative"
            v-if="role_modules.some((item) => item.value == 'exam.create')"
          >
            Manual Grading
            <span
              v-if="manual_grading_counts > 0"
              class="badge badge-danger position-absolute top-0 start-100 translate-middle"
              style="background-color: red; color: white; border-radius: 50%; padding: 0.3em 0.6em; font-size: 0.75rem; transform: translateY(-25%);"
            >
              {{ manual_grading_counts }}
            </span>
          </b-button>
        </div>
      </div>
    </div>
    <div class="">
      <div class="">
        <DataTable ref="list" />
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "./components/DataTable.vue";

export default {
  components: { DataTable },
  data() {
    return {
      manual_grading_counts: 0,
    };
  },
  methods: {
    goToCreateExam() {
      this.$router.push({ name: "CreateExamPage" });
    },
    gotoManualGradingExam() {
      this.$router.push({ name: "ManualGradingPage" });
    },
    fetchExamWithManualGrading() {
      this.$store.dispatch("exam/getExamsWithManualGrading").then((res) => {
        let data = res.data;
        this.manual_grading_counts = data.count;
      });
    },
  },
  created() {
    if (this.role_modules.some((item) => item.value == "exam.create")) {
      this.fetchExamWithManualGrading();
    }
  },
};
</script>
